import React from 'react'
import PropTypes from 'prop-types'

import { Motion, Wrapper } from 'Components/UI'
import { Image, Text } from 'Components/UI/_Legacy'

import isEmpty from 'lodash/isEmpty'
import map from 'lodash/map'
import size from 'lodash/size'

import { CLIENTS_FEEDBACK } from 'Constants/Projects/clientsFeedback'
import { PROJECTS_DATA } from 'Constants/Projects/projectAdditionalData'

import { Container, Content, ImageHolder, Info } from './styles'

function ClientFeedback({ projectId }) {
  const project = PROJECTS_DATA.find(item => item.projectId === projectId)

  if (isEmpty(project)) return null

  const feedbacks = []
  project.feedbacksId.forEach(feedbackId => {
    const feedback = CLIENTS_FEEDBACK.find(item => item.id === feedbackId)
    feedbacks.push(feedback)
  })

  if (!size(feedbacks)) return null

  return (
    <Container>
      <Wrapper alignItems="flex-start" flexDirection="column">
        <Text as="h2" legacyTitle lineHeight={1}>
          Client feedback
        </Text>

        {map(feedbacks, entity => (
          <Content key={entity?.id} mt={[16, 48]}>
            <Motion>
              {entity?.image && (
                <ImageHolder>
                  {/* 276px column on desktop, full width below lg. */}
                  <Image
                    alt={entity?.fullName ? `Photo of ${entity.fullName}` : ''}
                    image={entity?.image}
                    lazy
                    sizes="(max-width: 992px) 100vw, 276px"
                  />
                </ImageHolder>
              )}
            </Motion>

            <Motion>
              <Info>
                <Text
                  as="h3"
                  fontSize={[20, 32]}
                  letterSpacing={1.5}
                  lineHeight={1}
                  medium
                >
                  {entity?.fullName}
                </Text>

                <Text light mt="4px">
                  {entity?.positionHeld}
                </Text>

                <Text light mt="8px">
                  {entity?.text}
                </Text>
              </Info>
            </Motion>
          </Content>
        ))}
      </Wrapper>
    </Container>
  )
}

ClientFeedback.defaultProps = {
  projectId: '',
}

ClientFeedback.propTypes = {
  projectId: PropTypes.string,
}

export default ClientFeedback
